import axios from "axios";
import React, { useEffect, useState } from "react";

// ✅ For PDF download
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const AcceptedOrders = () => {
  const [acceptedOrders, setAcceptedOrders] = useState([]);

  useEffect(() => {
    axios
      .get("https://ezer-eventapp.onrender.com/accepted")
      .then((res) => setAcceptedOrders(res.data.reverse()))
      .catch((err) => console.log(err));
  }, []);

  // ✅ Delete order
  const deleteAccepted = (orderId) => {
    axios
      .delete(`https://ezer-eventapp.onrender.com/${orderId}`)
      .then(() => {
        alert("Order deleted successfully");
        setAcceptedOrders(acceptedOrders.filter((o) => o.id !== orderId));
      })
      .catch((err) => console.log(err));
  };

  // ✅ Download order as PDF (Always works)
  const downloadOrder = (order) => {
    const doc = new jsPDF();

    // ---- Shop Header ----
    doc.setFontSize(18);
    doc.text("SV WHOLESALE", 14, 20);

    doc.setFontSize(12);
    doc.text("123 Main Street, City, India", 14, 28);
    doc.text("Phone: +91 9876543210", 14, 34);
    doc.text("Email: shop@example.com", 14, 40);

    // ---- Invoice Title ----
    doc.setFontSize(16);
    doc.text("Accepted Order Invoice", 14, 55);

    // ---- Customer details ----
    doc.setFontSize(12);
    doc.text(`Order ID: ${order.id}`, 14, 65);
    doc.text(`Customer: ${order.name}`, 14, 72);
    doc.text(`Mobile: ${order.mobile}`, 14, 79);
    doc.text(`Address: ${order.address}`, 14, 86);
    doc.text(`Date: ${order.date}`, 14, 93);

    // ---- Table for items ----
    const items = order.variants?.map((item, index) => [
      index + 1,
      item.name,
      item.variant.weight,
      item.qty,
      `₹${item.variant.price}`,
      `₹${item.subtotal}`,
    ]);

    autoTable(doc, {
      head: [["S.No", "Item", "Weight", "Qty", "Price", "Subtotal"]],
      body: items,
      startY: 105,
    });

    // ---- Total after table ----
    const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 115;
    doc.setFontSize(14);
    doc.text(`Total: ₹${order.total}`, 14, finalY + 10);

    // ---- Footer ----
    doc.setFontSize(10);
    doc.text("Thank you for shopping with us!", 14, finalY + 20);

    // ✅ Save PDF instantly
    doc.save(`order_${order.id}.pdf`);
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-5">Accepted Orders</h1>
      {acceptedOrders.length === 0 ? (
        <p className="text-center text-bg-warning">No accepted orders yet</p>
      ) : (
        <div className="table-responsive" style={{ maxHeight: "500px" }}>
          <table className="table table-bordered table-hover">
            <thead className="table-dark text-center sticky-top">
              <tr>
                <th>S.NO</th>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Mobile</th>
                <th>Address</th>
                <th>Items</th>
                <th>Total (₹)</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {acceptedOrders.map((order, index) => (
                <tr key={order.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{order.orderId}</td>
                  <td>{order.name}</td>
                  <td>{order.mobile}</td>
                  <td>{order.address}</td>
                  <td className="items-col">
                    <ul className="order-items mb-0">
                      {order.variants?.map((item) => (
                        <li key={item.id}>
                          {item.name} {item.variant.weight} ({item.qty} × ₹
                          {item.variant.price}) ={" "}
                          <strong>₹{item.subtotal}</strong>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    <strong>₹{order.total}</strong>
                  </td>
                  <td>{order.date}</td>
                  <td className="text-center">
                    <button
                      onClick={() => downloadOrder(order)}
                      className="btn btn-info btn-sm me-2"
                    >
                      Download
                    </button>
                    {/* <button
                      onClick={() => deleteAccepted(order.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AcceptedOrders;
